import { isDefined } from '@app/utils/is';
import { useParams } from 'react-router-dom';

import { PageContent } from './CmsPageContent';

export const CmsPage = () => {
  const { id, pageSlug } = useParams<{ id: string; pageSlug: string }>();

  if (!isDefined(id) || !isDefined(pageSlug)) {
    return null;
  }

  return <PageContent pageSlug={pageSlug} orderId={id} />;
};
